import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutRightTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../components/SectionTitle';

import { IFormValues, IFormWatch } from 'routes/Main/type';

const radioId = [
  'respiration',
  'hypercapnic',
  'spo2_yes',
  'spo2_no',
  'room_air',
  'temperatur',
  'systolic',
  'pulse',
  'consciousness',
];
const contentLabel = [
  {
    id: 1,
    ko: 'Respiratory rate, breaths per minute',
    desc: ['≤ 8', '9~11', '12~20', '21~24', '≥ 25'],
    score: ['3점', '1점', '0점', '2점', '3점'],
  },
  {
    id: 2,
    ko: 'Hypercapnic respiratory failure',
    desc: [
      'If yes, proceed to question ‘SpO₂ (yes)’',
      'If no, proceed to question ‘SpO₂ (No)’',
    ],
    score: ['Yes', 'No'],
  },
  {
    id: 3,
    ko: 'SpO₂ (Yes)',
    desc: [
      '≤ 83%',
      '84~85%',
      '86~87%',
      '88-92%, ≥93% on room air',
      '93-94% on supplemental O₂',
      '95-96% on supplemental O₂',
      '≥97% on supplemental O₂',
    ],
    score: ['3점', '2점', '1점', '0점', '1점', '2점', '3점'],
  },
  {
    id: 4,
    ko: 'SpO₂ (No)',
    desc: ['≤ 91%', '92~93%', '94~95%', '≥ 96%'],
    score: ['3점', '2점', '1점', '0점'],
  },
  {
    id: 5,
    ko: 'Room air or supplemental O₂',
    desc: ['Supplemental O₂', 'Room Air'],
    score: ['2점', '0점'],
  },
  {
    id: 6,
    ko: 'Temperature',
    desc: [
      '≤35.0°C (95°F)',
      '35.1-36.0°C (95.1-96.8°F)',
      '36.1-38.0°C (96.9-100.4°F)',
      '38.1-39.0°C (100.5-102.2°F)',
      '≥39.1°C (102.3°F)',
    ],
    score: ['2점', '1점', '0점', '1점', '2점'],
  },
  {
    id: 7,
    ko: 'Systolic BP, mmHg',
    desc: [
      '≤ 90 mmHg',
      '91~100 mmHg',
      '101~110 mmHg',
      '111~219 mmHg',
      '≥ 220 mmHg',
    ],
    score: ['3점', '2점', '1점', '0점', '3점'],
  },
  {
    id: 8,
    ko: 'Pulse, beats per minute',
    desc: ['≤ 40 ', '41~50 ', '51~90', '91~110', '111~130', '≥ 131 '],
    score: ['3점', '1점', '0점', '1점', '2점', '3점'],
  },
  {
    id: 9,
    ko: 'Consciousness',
    desc: [
      'Alert',
      'New-onset confusion (or disorientation/agitation), responds to voice, responds to pain, or unresponsive',
    ],
    score: ['0점', '3점'],
  },
];

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}
const NEWS2Contents = (props: Props) => {
  const { disabled, setValue, getValues } = props;

  const [sumValue, setSumValue] = useState(0);

  const calculateSumValue = () => {
    setSumValue(
      radioId.reduce((acc, cur) => {
        if (cur === 'respiration') {
          if (Number(getValues('respiration')) === 1) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('respiration')) === 2) {
            const value = Number(getValues(cur)) - 1;
            return value ? acc + value : acc;
          } else if (Number(getValues('respiration')) === 3) {
            const value = Number(getValues(cur)) - 3;
            return value ? acc + value : acc;
          } else if (
            Number(getValues('respiration')) === 4 ||
            Number(getValues('respiration')) === 5
          ) {
            const value = Number(getValues(cur)) - 2;
            return value ? acc + value : acc;
          }
        } else if (cur === 'hypercapnic') {
          const value = Number(getValues(cur)) * 0;
          return value ? acc + value : acc;
        } else if (cur === 'spo2_yes') {
          if (Number(getValues('spo2_yes')) === 1) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('spo2_yes')) === 3) {
            const value = Number(getValues(cur)) - 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('spo2_yes')) === 4) {
            const value = Number(getValues(cur)) - 4;
            return value ? acc + value : acc;
          } else if (
            Number(getValues('spo2_yes')) === 5 ||
            Number(getValues('spo2_yes')) === 6 ||
            Number(getValues('spo2_yes')) === 7
          ) {
            const value = Number(getValues(cur)) - 4;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur));
          return value ? acc + value : acc;
        } else if (cur === 'spo2_no') {
          if (Number(getValues('spo2_no')) === 1) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('spo2_no')) === 4) {
            const value = Number(getValues(cur)) - 4;
            return value ? acc + value : acc;
          } else if (Number(getValues('spo2_no')) === 3) {
            const value = Number(getValues(cur)) - 2;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur));
          return value ? acc + value : acc;
        } else if (cur === 'room_air') {
          if (Number(getValues('room_air')) === 1) {
            const value = Number(getValues(cur)) + 1;
            return value ? acc + value : acc;
          } else if (Number(getValues('room_air')) === 2) {
            const value = Number(getValues(cur)) - 2;
            return value ? acc + value : acc;
          }
        } else if (cur === 'temperatur') {
          if (Number(getValues('temperatur')) === 1) {
            const value = Number(getValues(cur)) + 1;
            return value ? acc + value : acc;
          } else if (Number(getValues('temperatur')) === 2) {
            const value = Number(getValues(cur)) - 1;
            return value ? acc + value : acc;
          } else if (
            Number(getValues('temperatur')) === 3 ||
            Number(getValues('temperatur')) === 4 ||
            Number(getValues('temperatur')) === 5
          ) {
            const value = Number(getValues(cur)) - 3;
            return value ? acc + value : acc;
          }
        } else if (cur === 'systolic') {
          if (Number(getValues('systolic')) === 1) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (
            Number(getValues('systolic')) === 3 ||
            Number(getValues('systolic')) === 5
          ) {
            const value = Number(getValues(cur)) - 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('systolic')) === 4) {
            const value = Number(getValues(cur)) - 4;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur));
          return value ? acc + value : acc;
        } else if (cur === 'pulse') {
          if (Number(getValues('pulse')) === 1) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (Number(getValues('pulse')) === 2) {
            const value = Number(getValues(cur)) - 1;
            return value ? acc + value : acc;
          } else if (
            Number(getValues('pulse')) === 3 ||
            Number(getValues('pulse')) === 4 ||
            Number(getValues('pulse')) === 5 ||
            Number(getValues('pulse')) === 6
          ) {
            const value = Number(getValues(cur)) - 3;
            return value ? acc + value : acc;
          }
        } else if (cur === 'consciousness') {
          if (Number(getValues('consciousness')) === 1) {
            const value = Number(getValues(cur)) - 1;
            return value ? acc + value : acc;
          } else if (Number(getValues('consciousness')) === 2) {
            const value = Number(getValues(cur)) + 1;
            return value ? acc + value : acc;
          }
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue();
  };

  useEffect(() => {
    calculateSumValue();
  }, []);

  return (
    <>
      <SectionTitle title="NEWS 2 (National Early Warning Score 2)" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                sx={{
                  padding: '16px',
                  textAlign: 'center',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellWithoutLeftTwo
                sx={{ width: '50px' }}
              ></StyledTableCellWithoutLeftTwo>
              <StyledTableCellWithoutLeftTwo
                sx={{ padding: '16px', paddingLeft: '103px' }}
              ></StyledTableCellWithoutLeftTwo>
              <StyledTableCellTwo></StyledTableCellTwo>
            </TableRow>
          </TableHead>

          <TableBody>
            {contentLabel.map(
              (
                content: {
                  id: number;
                  ko: string;
                  desc: string[];
                  score: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    align="center"
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutRightTwo>
                    {content.score.map((a, i) => (
                      <TableRow sx={{ height: '44px', lineHeight: '44px' }}>
                        <Box sx={{ minWidth: '50px', textAlign: 'center' }}>
                          {a}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutRightTwo>
                  <StyledTableCellWithoutLeftRightTwo>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '44px',
                          lineHeight: '44px',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '100px',
                            minWidth: '500px',
                            color: content.id === 2 ? 'red' : '',
                          }}
                        >
                          {v}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRightTwo>
                  <StyledTableCellWithoutLeftTwo>
                    <RadioGroup
                      name={radioId[content.id - 1]}
                      defaultValue={Number(getValues(radioId[content.id - 1]))}
                    >
                      {content.desc.map((_, i) => {
                        return (
                          <TableRow
                            sx={{
                              height: '44px',
                              lineHeight: '44px',
                              textAlign: 'center',
                            }}
                          >
                            <Box
                              sx={{
                                width: '300px',
                                paddingLeft: '550px',
                                paddingRight: '70px',
                              }}
                            >
                              <Radio
                                disabled={disabled}
                                name={radioId[content.id - 1]}
                                value={i + 1}
                                onChange={handleChange}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            합계: {sumValue}점
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default NEWS2Contents;
